import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    selectedScholarship: null,
    selectedEducationProgram: null,
    educationPrograms: [],
    loading: false,
    error: null
};

const scholarshipSlice = createSlice({
    name: 'scholarship',
    initialState,
    reducers: {
        setSelectedScholarship: (state, action) => {
            state.selectedScholarship = action.payload;
            // Automatically set education programs when scholarship is selected
            state.educationPrograms = action.payload?.educationPrograms || [];
        },
        setSelectedEducationProgram: (state, action) => {
            state.selectedEducationProgram = action.payload;
        },
        setEducationPrograms: (state, action) => {
            state.educationPrograms = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        clearScholarshipData: (state) => {
            state.selectedScholarship = null;
            state.selectedEducationProgram = null;
            state.educationPrograms = [];
            state.error = null;
        }
    }
});

export const {
    setSelectedScholarship,
    setSelectedEducationProgram,
    setEducationPrograms,
    setLoading,
    setError,
    clearScholarshipData
} = scholarshipSlice.actions;

// Selectors to easily access nested data
export const selectSelectedScholarship = (state) => state.scholarship.selectedScholarship;
export const selectEducationPrograms = (state) => state.scholarship.educationPrograms;
export const selectSelectedEducationProgram = (state) => state.scholarship.selectedEducationProgram;

// Selector to get requirements from the selected education program
export const selectRequirements = (state) => {
    return state.scholarship.selectedEducationProgram?.requirements || [];
};

// Selector to get all requirements from all education programs of the selected scholarship
export const selectAllRequirements = (state) => {
    const programs = state.scholarship.educationPrograms || [];
    return programs.flatMap(program => program.requirements || []);
};

export default scholarshipSlice.reducer; 